(() => {
  const configNode = document.querySelector('[data-lm-cart-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const rootUrl = config.rootUrl.replace(/\/?$/, '/');
  const catalog = window.LeManuscrisCoffretCatalog.load(config.catalog, {rootUrl: config.rootUrl, previewThemeId: config.previewThemeId});
  let busy = false;
  const message = text => {
    let node = document.querySelector('[data-lm-cart-message]');
    if (!node) {node = document.createElement('p');node.dataset.lmCartMessage = '';node.setAttribute('role', 'alert');node.className = 'lm-cart-message';(document.querySelector('.cart__footer') || document.querySelector('.cart-drawer__footer') || document.body).append(node);}
    node.textContent = text;
  };
  const checkout = async event => {
    if (!document.querySelector('[data-lm-coffret-group]')) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (busy) return;
    busy = true;message('');
    try {
      const response = await fetch(rootUrl + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (!window.LeManuscrisCoffretNative.validateCart(await catalog, cart)) {message(config.invalid);return;}
      window.location.assign(rootUrl + 'checkout');
    } catch {message(config.error);}
    finally {busy = false;}
  };
  document.addEventListener('click', event => {if (event.target.closest('[name="checkout"]')) checkout(event);}, true);
  document.addEventListener('submit', event => {if (event.submitter?.name === 'checkout') checkout(event);}, true);
})();
